import React, { useRef, useState, useEffect } from "react";
import { withRouter } from "../../app-services/lib/router-compat";
import CheckoutSteps from "../preview/CheckoutSteps/CheckoutSteps";
import HTMLFlipBook from "react-pageflip";
import "./Custombookpreview.css";

export function Custombookpreview(props) {
  const { onFetch = (...arg) => api.getSelfPublish(...arg) } = props;
  const CUSTOMBOOKID = props.bookDetails.id;
  const $ele = useRef(null);
  const selfRef = useRef(null);
  const prevStateRef = useRef(null);
  if (!selfRef.current) {
    selfRef.current = {};
  }
  const self = selfRef.current;
  self.props = props;
  self.onFetch = onFetch;
  self.CUSTOMBOOKID = CUSTOMBOOKID;
  self.$ele = $ele;

  const [state, setStateRaw] = useState({
    pages: [],
    bookDetails: null,
    productDetails: null,
    answers: {},
    parsedBook: null,
    bookobj: null,
  });

  self.state = state;
  self.setState = (update, callback) => {
    setStateRaw((prev) => {
      const next = typeof update === "function" ? update(prev) : { ...prev, ...update };
      return next;
    });
    if (callback) setTimeout(callback, 0);
  };

  initialConstruct.bind(self)("BookPreview", props);

  self.onBookSetup = (bookobj) => {
    self.setState((prev) => ({ ...prev, bookobj }));
    let previewPageNo = localStorage.getItem("previewPageNo");
    if (previewPageNo) {
      setTimeout(() => {
        bookobj.turnToPage(Number(previewPageNo));
        localStorage.removeItem("previewPageNo");
      }, 100);
    }
  };

  self.getPages = () => {
    let { getPayload } = self.props;
    return new Promise((resolve, reject) => {
      getPayload()
        .then((book) => {
          resolve(
            Object.entries(book).map(([key, value], i) => ({
              pagetype: key,
              name: key,
              label: i + 1,
              content: value.html,
            }))
          );
        })
        .catch((err) => reject(err));
    });
  };

  self.getProductDetails = () => {
    let { bookDetails } = self.props;
    api.getBookDetails(bookDetails.bookId).then((res) => {
      self.setState((prev) => ({
        ...prev,
        productDetails: res.data.bookDetails,
      }));
    });
  };

  self.getBookDetails = () => {
    let { bookDetails } = self.props;
    return new Promise((resolve, reject) => {
      if (bookDetails.id) {
        self.onFetch(bookDetails.id).then((responce) => {
          if (responce.data && Object.keys(responce.data).length) {
            let savedBookObj = responce.data || { savedBook: "{}" };
            let parsedBook = savedBookObj.savedBook?.parse() || {};
            self.setState((prev) => ({
              ...prev,
              bookDetails: savedBookObj,
              parsedBook,
            }));
            resolve(savedBookObj);
          }
        });
      }
    });
  };

  self.getPageSize = (name) => {
    let { bookname } = self.props;
    let booksize = self.$store?.bookSize?.[bookname];
    if (booksize && booksize[name]) {
      return `${booksize[name]}${booksize["unit"]}`;
    } else {
      return "";
    }
  };

  self.getCorrection = (attributeName) => {
    let device = self.$store?.device;
    let correct = 0;
    let { bookname } = self.props;
    if (["picture-book", "handprint-book"].includes(bookname)) {
      switch (device) {
        case "desk":
          correct = `${(1 - 0.8).toFixed(2).parse() * 200}mm`.toPx();
          break;
        case "lap":
        case "mac":
          correct = `${(1 - 0.6).toFixed(2).parse() * 200}mm`.toPx();
          break;
      }
    }
    return correct;
  };

  self.onPage = (obj, i, arr) => {
    return {
      ...obj,
      content: () => (
        <div>
          <div dangerouslySetInnerHTML={{ __html: obj.content || "" }}></div>
          <div className="col text-center">
            <b>{obj.label}</b> / {arr.length}
          </div>
        </div>
      ),
    };
  };

  self.onAnswer = (value, key) => {
    let { answers } = self.state;
    let { onUpdate } = self.props;
    if (key == "dedication") {
      onUpdate(key, value);
    }
    self.setState((prev) => ({
      ...prev,
      answers: {
        ...prev.answers,
        [key]: value,
      },
    }));
  };

  self.onDedicationSave = () => {
    let { saveBook } = self.props;
    let { bookname } = self.props;
    return new Promise((resolve, reject) => {
      saveBook()
        .then(() => {
          self.props.alert.close();
          setTimeout(() => {
            if (bookname === "customcharacter-book") {
              localStorage.setItem("previewPageNo", 18);
            }
            document.querySelector(".right-toolbar #previewBook").click();
            resolve();
          }, 100);
        })
        .catch(reject);
    });
  };

  self.checkoutSave = () => {
    return new Promise((resolve, reject) => {
      self.onDedicationSave().then(() => {
        let { bookDetails } = self.state;
        self.setState((prev) => ({
          ...prev,
          productDetails: { ...bookDetails, triggeradd2cart: true },
        }));
        self.setStore("triggeradd2cart", true);
      });
    });
  };

  self.addToCart = () => {
    let cartProps = self.props;
    let { productDetails, answers } = self.state;
    let { saveBook, getPayload } = cartProps;
    let { bookDetails } = self.state;
    let { history } = self;
    mixins.checkLogin(history).then(async (user) => {
      if (!productDetails) {
        self.checkoutSave();
        return;
      } else {
        let payload = await getPayload();
        await emit.trigger("updatebook", payload);
      }
      Modal.state.list.filter((o) => o.type == "alert")[0]?.close();
      if (localStorage.getItem("editmode") === "true") {
        api
          .updateToCart(
            {
              promotionId: null,
              productId: productDetails?.product?.id,
              quantity: 1,
              price: productDetails?.book?.bookPrice,
              discount: null,
              bookCover: answers.cover || null,
              customProductId: cartProps.store.cartdetails?.customProductId,
            },
            cartProps.store.cartdetails?.id
          )
          .then((res) => {
            localStorage.setItem("editmode", false);
            if (res && res.statusCode === 200) {
              cartProps.alert.close();
              history.push("/checkout-page");
            } else {
              alert("Something went wrong please try again later..");
            }
          });
      } else {
        api
          .addToCart({
            promotionId: null,
            productId: productDetails?.product?.id,
            quantity: 1,
            price: productDetails?.book?.bookPrice,
            discount: null,
            bookCover: answers.cover || null,
            customBookId: bookDetails.customBook.id,
          })
          .then((res) => {
            if (res && res.statusCode === 200) {
              cartProps.alert.close();
              history.push("/checkout-page");
              mixins.reFectchSavedBookDetails(self.props);
            } else {
              alert("Something went wrong please try again later..");
            }
          });
      }
    });
  };

  self.getStepKeys = () => {
    let { productDetails, bookDetails } = self.state;
    let { bookname } = self.props;
    switch (bookname) {
      case "customcharacter-book":
        return ["edit", "dedication"];
      case "handprint-book":
        return ["edit"];
      default:
        return [];
    }
  };

  useEffect(() => {
    window.Custombookpreview = self;
    self.getPages().then((pages) => {
      self.setState((prev) => ({
        ...prev,
        pages,
      }));
      self.getBookDetails().then(() => {
        self.getProductDetails();
      });
    });
  }, []);

  useEffect(() => {
    mixins.debounce(document, () => {}, "customCharacter.8.ans.dedication");
    const prevState = prevStateRef.current || state;
    self.watch(
      {
        productDetails: function (val) {
          if (props.store.triggeradd2cart) {
            this.setStore("triggeradd2cart", false);
            setTimeout(() => {
              this.addToCart();
            });
          }
        },
      },
      state,
      prevState
    );
    prevStateRef.current = state;
  }, [state.productDetails, props.store.triggeradd2cart]);

  const {
    alert,
    message,
    closablePreview = true,
    onPreviewClose = (a) => a.close(),
    bookname,
  } = props;
  const { pages, bookDetails, productDetails } = state;

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-md-10 offset-md-1">
            <div className={"bookView " + bookname}>
              {closablePreview && (
                <i
                  className="close fa fa-times"
                  onClick={() => onPreviewClose(alert)}
                ></i>
              )}
              {pages.length > 0 && (
                <HTMLFlipBook
                  width={330}
                  height={500}
                  size="stretch"
                  maxShadowOpacity={0.5}
                  showCover={false}
                  mobileScrollSupport={true}
                  className="demo-book"
                >
                  {pages.map((o, index) => {
                    return (
                      <div
                        key={index}
                        className={"demoPage " + (o.pagetype == 'ch7frontpage1' || o.pagetype == 'chapterNineFrontpage' ? 'dual left' :  o.pagetype == 'ch7frontpage2' || o.pagetype == 'chapterNineFrontpage2' ? 'dual right' : 'single')}
                        style={{ position: "relative" }}
                        dangerouslySetInnerHTML={{ __html: o?.content }}
                      ></div>
                    );
                  })}
                </HTMLFlipBook>
              )}
            </div>
            {message && (
              <div
                className="col text-center"
                style={{ fontWeight: "bold", color: "red" }}
                dangerouslySetInnerHTML={{ __html: message }}
              ></div>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="my-5">
              {
                <CheckoutSteps
                  keys={self.getStepKeys()}
                  addToCart={() => self.addToCart()}
                  onAnswer={(v, k) => self.onAnswer(v, k)}
                  onSave={(v) => self.onDedicationSave(v)}
                  bookname={bookname}
                />
              }
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default connect(withRouter(Custombookpreview));
